import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useHistory, Link } from "react-router-dom";
import apiService from "../services/api.service";
import "./login.css";

const RequestReset = () => {
  let history = useHistory()
  const [username, setUsername] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const onUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonDisabled(true)
    try {
      await apiService.resetRequest(username);
      localStorage.removeItem('authError')
      history.push('/login', { 'successReason': "Richiesta inviata, controlla la tua email per resettare la password" })

    } catch (error) {
        history.push('/login', { 'failReason': "Richiesta fallita, hai inserito la email correttamente?" })
    }
  };


  return (
    <div className="login-page login-page--platform">
      <div className="login-card">
        <p className="login-kicker">Area riservata</p>
        <h1 className="login-title">Reimposta password</h1>
        <p className="login-subtitle">
          Inserisci la email con cui hai effettuato la registrazione. Riceverai un link per impostare una nuova password.
        </p>
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              required
              type="email"
              placeholder="Inserisci la email"
              value={username}
              onChange={onUsernameChange}
              autoComplete="email"
            />
          </Form.Group>
          <Button
            className="login-submit"
            size="lg"
            variant="primary"
            disabled={buttonDisabled}
            type="submit">
            Invia richiesta
          </Button>
        </Form>
        <p className="login-register-prompt">
          Ricordi la password? <Link to="/login">Accedi</Link>
        </p>
      </div>
    </div>
  );
};

export default RequestReset;
